import { Pipe, PipeTransform } from '@angular/core';
import { CheckboxStatus } from '../common';

@Pipe({
  standalone: true,
  name: 'checkboxStatusChecker',
})
export class CheckboxStatusCheckerPipe<T> implements PipeTransform {
  constructor() {}

  transform(source: T[], selected: T[], type: CheckboxStatus): boolean {
    let isChecked: boolean = false;
    if (type === CheckboxStatus.ALL_SELECTED) {
      isChecked = source?.every((item) => selected.includes(item));
    } else if (type === CheckboxStatus.INDETERMINATE) {
      isChecked =
        (source?.some((item) => selected.includes(item)) && !selected.every((item) => source.includes(item))) ||
        (source?.some((item) => selected.includes(item)) && !source.every((item) => selected.includes(item)));
    }

    return isChecked;
  }
}
